import type { IBriefInfluencerSearchRequestV2 } from "@shared/lib/types/briefInfluencerV2";

type UserIdsFilter = string[] | { userIds?: string[] };
type InfluencerCostFilter = NonNullable<
  IBriefInfluencerSearchRequestV2["influencerCost"]
>;

type BriefInfluencerSearchParams = Partial<IBriefInfluencerSearchRequestV2> & {
  assignedPricingPocV2?: UserIdsFilter;
};

function toUserIdsPayload(
  value?: UserIdsFilter
): { userIds: string[] } | undefined {
  if (!value) return undefined;
  const userIds = Array.isArray(value) ? value : value.userIds;
  if (!userIds || userIds.length === 0) return undefined;
  return { userIds };
}

function mapInfluencerCost(
  cost?: InfluencerCostFilter
): InfluencerCostFilter | undefined {
  if (!cost) return undefined;

  const offerStatus = cost.offerStatus?.includes("")
    ? []
    : cost.offerStatus;
  const date =
    cost.date?.from || cost.date?.to ? cost.date : undefined;
  const createdByType = cost.createdByType?.length
    ? cost.createdByType
    : undefined;

  if (!date && offerStatus === undefined && !createdByType) {
    return undefined;
  }

  return {
    date,
    offerStatus,
    createdByType,
  };
}

/** Shape the API expects after UI filter fields are normalized. */
export function mapBriefInfluencerSearchParams<
  T extends BriefInfluencerSearchParams,
>(params?: T) {
  const source = params ?? ({} as T);

  return {
    ...source,
    influencerCost: mapInfluencerCost(source.influencerCost),
    sortByDynamicFields: source.sortByDynamicFields || {},
    assignedPricingPocV2: toUserIdsPayload(source.assignedPricingPocV2),
  };
}
